import React, { useEffect, useState } from 'react';

import { Button, Modal } from 'react-bootstrap';
import { useIntl } from 'react-intl';

import { useAppSelector } from 'hooks';
import { useAxios } from 'configs/requests';
import { Error, Loading } from 'components/Fetch';

import { Content } from './EducationalContent';

interface IDeleteMessageModalProps {
  setShow: (show: boolean) => any;
  show: boolean;
  educationalContent: ICarePlanEducationalContent;
  onDelete: any;
  carePlanTemplate?: ICarePlanTemplate;
}

const DeleteEducationalContentModal = ({
  show,
  setShow,
  educationalContent,
  onDelete,
  carePlanTemplate
}: IDeleteMessageModalProps) => {
  const intl = useIntl();
  const patientUid = useAppSelector(({ patient }) => patient.data?.uid);
  const [error, setError] = useState<any>(false);

  const [{ loading, error: postError }, post] = useAxios(
    {
      url: carePlanTemplate
        ? '/clinician/2.0.0/CarePlanTemplate'
        : `/clinician/Patient/${patientUid}/CarePlan`,
      method: 'POST'
    },
    { manual: true }
  );

  const handleDelete = async () => {
    const educationalContentToDelete = {
      ...educationalContent,
      edit_status: 'deleted'
    };

    await post({
      data: {
        scheduled: [educationalContentToDelete],
        carePlanTemplate
      }
    });

    onDelete(educationalContent.id);
  };

  useEffect(() => {
    setError(postError);
  }, [postError, setError]);

  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      data-test="careplan-educational-contents-modal-delete"
    >
      <Modal.Header className="align-items-center">
        <Modal.Title>
          {intl.formatMessage({ id: 'deleteKey' }) +
            ' ' +
            intl.formatMessage({ id: 'educationalContentKey' })}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Content educationalContent={educationalContent} />
        {loading && <Loading className="mt-4" />}
        {error && (
          <Error
            retry={handleDelete}
            dismissible
            onClose={() => setError(false)}
            className="mt-4"
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="link" onClick={() => setShow(false)}>
          {intl.formatMessage({ id: 'Cancel' })}
        </Button>
        <Button variant="danger" onClick={handleDelete} data-test="careplan-educational-btn-delete">
          {intl.formatMessage({ id: 'deleteKey' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteEducationalContentModal;
